import React from "react";
import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import GoogleIcon from "@/assets/images/google.svg?react";
import PostgresIcon from "@/assets/images/postgresql.svg?react";
import SupabaseIcon from "@/assets/images/supabase.svg?react";
import type {
  BucketProviderKind,
  ConnectionType,
} from "components/canvas/leftSide/import/Postgres/savedConnectionsApi";

interface Props {
  type: ConnectionType;
  size?: number;
  className?: string;
}

/** MUI cloud-outline glyph wrapped to fit the same `(width, className)`
 *  signature as the brand SVGs below. */
export const BucketIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width,
  className,
}) => (
  <CloudOutlinedIcon
    sx={{ fontSize: typeof width === "number" ? width : 20 }}
    className={className}
  />
);

/** MUI storage glyph for local SQLite — no SQLite brand SVG yet; we pick
 *  a neutral file-storage icon so the connector is still recognizable. */
export const LocalSqliteIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width,
  className,
}) => (
  <StorageOutlinedIcon
    sx={{ fontSize: typeof width === "number" ? width : 20 }}
    className={className}
  />
);

export const ICON: Record<
  ConnectionType,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  postgres: PostgresIcon,
  supabase: SupabaseIcon,
  google_oauth: GoogleIcon,
  bucket: BucketIcon,
  local_sqlite: LocalSqliteIcon,
};

const LABEL: Record<ConnectionType, string> = {
  postgres: "Postgres",
  supabase: "Supabase",
  google_oauth: "Google",
  bucket: "Google Cloud Storage",
  local_sqlite: "Local SQLite",
};

export const BUCKET_PROVIDER_LABEL: Record<BucketProviderKind, string> = {
  s3: "Amazon S3",
  gcs: "Google Cloud Storage",
  azure: "Azure Blob Storage",
};

export const BUCKET_PROVIDER_TAG: Record<BucketProviderKind, string> = {
  s3: "S3",
  gcs: "GCS",
  azure: "Azure",
};

export const ConnectionTypeIcon: React.FC<Props> = ({
  type,
  size = 16,
  className,
}) => {
  const Icon = ICON[type];
  return (
    <Icon
      width={size}
      height={size}
      className={`text-fg-muted ${className ?? ""}`}
      aria-label={LABEL[type]}
    />
  );
};

export const connectionTypeLabel = (type: ConnectionType): string =>
  LABEL[type];
